import { useState } from 'react';
import React from 'react'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {  Slide } from "react-reveal";

// you can Add or update FAQs data here
const faqData = [
    {
        qs: 'What is  Meta Masks NFT?',
        ans: <p>Meta Masks is a collection of 9,999 unique NFTs inspired directly from the meta verse and virtual identity, making it possible for our Masked community to come together and be the next crypto punks. When you purchase a Meta mask is not only a unique piece of digital art but you gain access to the benefits and security of our community from holder rewards to monthly payments of royalties. Meta Masks unique collection of 9,999 are stored as ERC-721 tokens on the Ethereum blockchain.</p>,
    },
    {
        qs: 'What is an NFT?',
        ans: <p>A NFT is a non-fungible token, to which is something specific and unique that can’t be replaced. A NFT is Data that is accounted for in a digital certificate built on a blockchain, for example, represent a unique piece of art or a game token.</p>,
    },
    {
        qs: 'How can I buy a Meta Masks NFT?',
        ans: <p>You will be able to purchase your Meta Masks NFT on our website upon launch. For more information join our discord to ensure you don’t miss out</p>,
    },
    {
        qs: 'What does "MINT" mean?',
        ans: <p>Minting an NFT is allowing publishing your unique token so it can be purchased on the blockchain. </p>,
    },
    {
        qs: 'What is the Mint Price?',
        ans: <p>The price of minting and sale will be announced</p>,
    },
    {
        qs: 'Why Meta Masks',
        ans: <p>Meta Masks is the future of identity & benefits in the Metaverse, and what better way to represent your virtual avatar than with a unique piece of virtual art that not only looks epic, but also provides you with investment rewards such as monthly royalty payments and massive giveaway rewards for simply holding  . </p>,
    },

]

const Faq = () => {
    const [activeFaq, setActiveFaq] = useState(null);
    return (
        <section id="faq">
            <div className="container">
                <div className="sec-heading-wrapper">
                <Slide bottom>    <h1 className="sec-heading">FAQ</h1></Slide>
                </div>
                {faqData.map((data, i) => {
                    return (
                        <Slide key={i}  top>
                            <div
                                className={`faq-wrapper ${activeFaq === i ? 'active-faq' : ''}`}>
                                <div className="faq-qs" onClick={() => setActiveFaq(prev => prev === i ? null : i)}>
                                    <h6>{data.qs}</h6><span className="faq-arrow"><ArrowForwardIosIcon /></span>
                                </div>
                                <div className="faqs-answer text-white">
                                    {data.ans}
                                </div>
                            </div>
                        </Slide>
                    )
                })}
            </div>
        </section>
    )
}

export default Faq
